<template>
  <div :class="b()">
    <h1
      v-if="config.heading"
      :class="b('heading')"
    >
      {{ config.heading }}
    </h1>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="config.description || config?.descriptionRight"
      :class="b('wrapper')"
    >
      <div
        v-if="config.description"
        v-html="config.description"
        :class="b('description')"
      ></div>
      <div
        v-if="config?.descriptionRight"
        v-html="config.descriptionRight"
        :class="b('description')"
      ></div>
    </div>
    <!-- eslint-enable vue/no-v-html -->

    <div
      v-if="!!config.ctaPrimary || !!config.ctaSecondary"
      :class="b('button-bar')"
    >
      <e-button
        v-if="!!config.ctaPrimary"
        :href="config.ctaPrimary.url"
        :target="config.ctaPrimary.target"
        :title="config.ctaPrimary.title"
        variant="primary"
        :class="b('button')"
      >
        {{ config.ctaPrimary.label }}
      </e-button>

      <e-button
        v-if="!!config.ctaSecondary"
        :href="config.ctaSecondary.url"
        :target="config.ctaSecondary.target"
        :title="config.ctaSecondary.title"
        variant="primary"
        :class="b('button')"
      >
        {{ config.ctaSecondary.label }}
      </e-button>
    </div>
  </div>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import eButton from '@/elements/e-button.vue';
  import { Link } from '@/types/link';

  // type Setup = {}
  // type Data = {}

  export type PageHeaderConfig = {
    heading: string | null;
    description: string | null;
    descriptionRight?: string | null;
    ctaPrimary: Link | null;
    ctaSecondary: Link | null;
  };
  /**
   * Shows the page header on f.e l-articles-list and l-categories-overview.
   */
  export default defineComponent({
    name: 'c-page-header',

    components: {
      eButton,
    },

    props: {
      /**
       * The config object for the Page Header
       */
      config: {
        type: Object as PropType<PageHeaderConfig>,
        required: true,
      },
    },
    // emits: {},

    // setup(): Setup {},
    // data(): Data {
    //   return {};
    // },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/mixins';

  .c-page-header {
    &__heading,
    &__wrapper {
      margin-bottom: 3rem;
    }

    &__wrapper {
      display: flex;
      gap: 1rem;
    }

    &__description {
      @include mixins.list-styles;

      flex: 1;

      ul {
        padding-inline-start: 1.5rem;
      }

      &:only-child {
        flex: 100%;
      }
    }

    &__button-bar {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      margin-bottom: 6rem;

      @include mixins.media(md) {
        justify-content: flex-start;
        flex-direction: row;
      }
    }
  }
</style>
